import { render, staticRenderFns } from "./AddEditGroup.vue?vue&type=template&id=1fc248d5&"
import script from "./AddEditGroup.vue?vue&type=script&lang=js&"
export * from "./AddEditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports